import {
  Accordion,
  Badge,
  Button,
  Card,
  Col,
  Form,
  Modal,
  Row,
  Spinner,
  Table,
} from 'react-bootstrap'
import {
  MarkSignatureFormAsViewedResponse,
  NodeSignatureFormsEntry,
} from '../../../types/signatureFormsEntriesApi'
import moment from 'moment'
import {prependBackendUrl} from '../../../gql/client'
import {MARK_SIGNAFTURE_FORMS_AS_VIEWED} from '../../../gql/mutations/signatureFormsMutations'
import {useMutation} from '@apollo/client'
import {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {URL} from '../../../gql/client'
import {parseId} from '../../../helpers'
import {useGetUser} from '../../../store/userStore'

const getBrowserAndOsLabel = (userAgent?: string | null) => {
  if (!userAgent) return '-'

  const ua = userAgent.toLowerCase()

  let os = 'Unknown OS'
  if (ua.includes('windows nt 10.0')) os = 'Windows 10/11'
  else if (ua.includes('windows nt 6.3')) os = 'Windows 8.1'
  else if (ua.includes('windows nt 6.1')) os = 'Windows 7'
  else if (ua.includes('iphone')) os = 'iOS (iPhone)'
  else if (ua.includes('ipad')) os = 'iOS (iPad)'
  else if (ua.includes('android')) os = 'Android'
  else if (ua.includes('mac os x')) os = 'macOS'
  else if (ua.includes('linux') || ua.includes('x11')) os = 'Linux'

  const pickVersion = (pattern: RegExp) => ua.match(pattern)?.[1] ?? ''

  let browser = 'Unknown Browser'
  let version = ''
  if (ua.includes('edg/')) {
    browser = 'Microsoft Edge'
    version = pickVersion(/edg\/(\d+)/)
  } else if (ua.includes('opr/')) {
    browser = 'Opera'
    version = pickVersion(/opr\/(\d+)/)
  } else if (ua.includes('chrome/')) {
    browser = 'Google Chrome'
    version = pickVersion(/chrome\/(\d+)/)
  } else if (ua.includes('firefox/')) {
    browser = 'Firefox'
    version = pickVersion(/firefox\/(\d+)/)
  } else if (ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('edg/')) {
    browser = 'Safari'
    version = pickVersion(/version\/(\d+)/)
  }

  return `${browser}${version ? ` ${version}` : ''} (${os})`
}

export const ModalPreview: React.FC<{
  onClose: () => void
  isOpen: boolean
  info: NodeSignatureFormsEntry
  refetch?: () => void
}> = ({info, isOpen, onClose, refetch}) => {
  const user = useGetUser((s) => s.user)
  const [gqlAddLogEntry, {data: dateEntryLog, loading: logadingEntryLog, error: erroEntryLog}] =
    useMutation<MarkSignatureFormAsViewedResponse>(MARK_SIGNAFTURE_FORMS_AS_VIEWED)

  useEffect(() => {
    if (isOpen && info.id) {
      gqlAddLogEntry({
        variables: {
          token: info.token, // Ajusta según tu mutation
        },
      })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, info.token])

  useEffect(() => {
    if (!dateEntryLog) return

    console.log(JSON.stringify(dateEntryLog))
  }, [gqlAddLogEntry, dateEntryLog])

  useEffect(() => {
    if (erroEntryLog) toast.error(`Error: ${erroEntryLog.message}`)
  }, [erroEntryLog])

  const handleDownloadExternalPdf = async () => {
    if (!user?.token) {
      toast.error('Unauthorized')
      return
    }
    try {
      const entryId = parseId(info.id)
      const res = await fetch(`${URL}/signatures/entries/${entryId}/download-external-pdf/`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      })
      if (!res.ok) throw new Error('Error downloading external PDF')

      const blob = await res.blob()
      const downloadUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = `signed_external_${entryId}.pdf`
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(downloadUrl)
      link.remove()
    } catch (error) {
      toast.error((error as Error).message || 'Error downloading external PDF')
    }
  }

  return (
    <Modal show={isOpen} onHide={onClose} size='xl'>
      <Modal.Header closeButton>
        <Modal.Title>{info.signatureForm.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{backgroundColor: '#f2f3f8'}}>
        {info.signedPdf && (
          <div className='mb-3 d-flex justify-content-end'>
            <a
              className='btn btn-outline-primary'
              href={prependBackendUrl(info.signedPdfUrl)}
              target='_blank'
              rel='noopener noreferrer'
              download
            >
              Download Signed PDF
            </a>
            <Button
              className='btn btn-outline-primary ms-2'
              onClick={handleDownloadExternalPdf}
            >
              Download Signed PDF to External
            </Button>
          </div>
        )}
        <Card>
          <Card.Body>
            <Form.Group>
              <Form.Label>Form Content</Form.Label>
              <div
                style={{
                  border: '1px solid #ced4da',
                  borderRadius: '0.375rem',
                  background: '#fff',
                  minHeight: 120,
                  padding: 12,
                  overflowX: 'auto',
                  width: '100%',
                }}
                dangerouslySetInnerHTML={{__html: info.renderedHtml || ''}}
              />
            </Form.Group>
            {info.signatureImage && (
              <div className='mt-3 text-center'>
                <Form.Label>Signature Image</Form.Label>
                <div>
                  <img
                    src={prependBackendUrl(info.signatureImageUrl)}
                    alt='Signature'
                    style={{
                      maxHeight: 150,
                      maxWidth: '100%',
                      border: '1px solid #ced4da',
                      borderRadius: '0.375rem',
                      padding: '6px',
                      background: '#fff',
                    }}
                  />
                </div>
              </div>
            )}
          </Card.Body>
        </Card>
        <Card className='cards-logs-enties'>
          <Card.Header>
            <h3>Signature trail log</h3>
          </Card.Header>
          <Card.Body>
            <Table striped hover responsive className='mb-0'>
              <thead>
                <tr>
                  <th>Timestamp</th>
                  <th>Action</th>
                  <th>Contact</th>
                  <th>User</th>
                  <th>IP</th>
                  <th>Region</th>
                  <th>Browser / OS</th>
                  <th>Mobile device</th>
                </tr>
              </thead>
              {logadingEntryLog ? (
                <Spinner animation='border' size='sm' className='me-2' />
              ) : (
                <>
                  {dateEntryLog && dateEntryLog.markSignatureFormAsViewed ? (
                    <>
                      <tbody>
                        {dateEntryLog.markSignatureFormAsViewed.logs &&
                        dateEntryLog.markSignatureFormAsViewed.logs.length > 0 ? (
                          dateEntryLog.markSignatureFormAsViewed.logs.map((log, index) => (
                            <tr key={index}>
                              <td>{moment(log.created).format('YYYY-MM-DD HH:mm:ss')}</td>
                              <td>{log.action}</td>
                              <td>{log.contact ?? '-'}</td>
                              <td>
                                {log.user ? `${log.user.firstName} ${log.user.lastName}` : '-'}
                              </td>
                              <td>{log.ipAddress ?? '-'}</td>
                              <td>{log.region ?? '-'}</td>
                              <td>{getBrowserAndOsLabel(log.browser)}</td>
                              <td>{log.isMobile ? 'Yes' : 'No'}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={8} className='text-center'>
                              No logs available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </>
                  ) : (
                    <tbody>
                      {info.logs && info.logs.length > 0 ? (
                        info.logs.map((log, index) => (
                          <tr key={index}>
                            <td>{moment(log.created).format('YYYY-MM-DD HH:mm:ss')}</td>
                              <td>{log.action}</td>
                              <td>{log.contact ?? '-'}</td>
                              <td>{log.user ? `${log.user.firstName} ${log.user.lastName}` : '-'}</td>
                              <td>{log.ipAddress ?? '-'}</td>
                              <td>{log.region ?? '-'}</td>
                              <td>{getBrowserAndOsLabel(log.browser)}</td>
                              <td>{log.isMobile ? 'Yes' : 'No'}</td>
                            </tr>
                          ))
                      ) : (
                        <tr>
                          <td colSpan={8} className='text-center'>
                            No logs available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  )}
                </>
              )}
            </Table>
          </Card.Body>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
